import { render, staticRenderFns } from "./VuesticSimplePalettePicker.vue?vue&type=template&id=cd5fa7ec&"
import script from "./VuesticSimplePalettePicker.vue?vue&type=script&lang=js&"
export * from "./VuesticSimplePalettePicker.vue?vue&type=script&lang=js&"
import style0 from "./VuesticSimplePalettePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticSimplePalettePicker.vue"
export default component.exports